import { EntityReference } from './entity-reference'

export interface TableState {
  //pageSize: number,
  //page: number,
  qualifier: string
  additionalQualifier: AdditionalQualifier
  sortMap: Map<string, SortingDefinition>
  pagination: { page: number; pageSize: number }
}

export interface SortingDefinition {
  sortDirection: SortDirection
  sortingOrder?: number
}

export enum SortDirection {
  NONE = 'NONE',
  ASC = 'ASC',
  DESC = 'DESC'
}

export class AdditionalQualifier {
  filter: string

  // ENTITY reference
  id: number
  dtoType: string

  // main reference
  mainId: number
  mainDtoType: string

  constructor(filter: string) {
    this.filter = filter
  }

  setId(id: number) {
    this.id = id
    return this
  }
  setDtoType(dtoType: string) {
    this.dtoType = dtoType
    return this
  }
  setEntityRef(entityRef: EntityReference): AdditionalQualifier {
    this.id = entityRef?.id
    this.dtoType = entityRef?.dtoType
    return this
  }

  setMainRef(mainId: number, mainType: string): AdditionalQualifier {
    this.mainId = mainId
    this.mainDtoType = mainType
    return this
  }
}
